import classNames from 'clsx';
import React, { useEffect, useState } from 'react';

import CircleIcon from '@swf/core/assets/icons/circle.svg';

import { backwards, forwards, full, loading, none } from './Loading.scss';

enum Stroke {
  Forwards,
  Backwards,
  Full,
  None
}

const duration = {
  [Stroke.Forwards]: 1000,
  [Stroke.Backwards]: 666.6666,
  [Stroke.Full]: 466.6666,
  [Stroke.None]: 66.6666
};
const sequence = {
  [Stroke.Forwards]: Stroke.Full,
  [Stroke.Full]: Stroke.Backwards,
  [Stroke.Backwards]: Stroke.None,
  [Stroke.None]: Stroke.Forwards
};
const classes = {
  [Stroke.Forwards]: forwards,
  [Stroke.Backwards]: backwards,
  [Stroke.Full]: full,
  [Stroke.None]: none
};

const Loading = () => {
  const [stroke, setStroke] = useState<Stroke>(Stroke.Forwards);

  useEffect(() => {
    const timeout = window.setTimeout(() => setStroke(sequence[stroke]), duration[stroke]);

    return () => {
      window.clearTimeout(timeout);
    };
  });

  return <CircleIcon className={classNames(loading, classes[stroke])} />;
};

export default Loading;
